module.exports = __webpack_public_path__ + "img/8.c874ba02.jpg";